import { Heart } from "lucide-react";

// Ko-fi profile ID and button styling.
// We deliberately do NOT load Ko-fi's Widget_2.js because its rendered button
// pulls the "Quicksand" webfont from Google Fonts, and we self-host all assets.
// Instead we render a native, theme-consistent button that opens Ko-fi in a new tab.
const KOFI_ID = "E3U623FYMS";
const KOFI_COLOR = "#F59E0B";
const KOFI_HOVER = "#D97706";
const KOFI_LABEL = "Support me";

export default function KofiButton() {
  return (
    <div className="flex justify-center" data-testid="kofi-container">
      <a
        href={`https://ko-fi.com/${KOFI_ID}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="kofi-link"
        className="inline-flex items-center gap-2 px-5 py-2.5 text-white font-bold text-sm rounded-full transition-colors shadow-sm"
        style={{
          backgroundColor: KOFI_COLOR,
          fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = KOFI_HOVER)}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = KOFI_COLOR)}
      >
        <Heart className="w-4 h-4" fill="currentColor" strokeWidth={0} />
        <span>{KOFI_LABEL}</span>
      </a>
    </div>
  );
}
